import React from 'react';
export function HomeSmallIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.54l-8-6.857-8 6.857V20h16v-9.46zM6 18v-6.54l6-5.143 6 5.143V18h-4v-4h-4v4H6z"
  }));
}